import classNames from 'classnames';
import { interpolate, ngettext } from '~/utils/localization';
import { DivTooltip } from '@wg/wows-react-uikit';
import Countdown from 'react-countdown';
import styles from './CountDown.scss';
import DefaultTooltip from '~/components/Tooltip/DefaultTooltip';

interface ICountDown {
    date: number | string;
    isLarge?: boolean;
    tooltipText?: string;
    completeText?: string;
    hideSeconds?: boolean;
    onComplete?: () => void;
    className?: string;
    notice?: boolean;
    withoutIcon?: boolean;
    dynamicSettings?: {
        maxDays?: number;
    };
}

interface RedrererData {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

const CountDown = (props: ICountDown) => {
    const { isLarge, date, tooltipText, onComplete, completeText } = props;

    const leadingZero = (num: number) => (num < 10 ? '0' : '');

    const renderer = ({ days, hours, minutes, seconds }: RedrererData) => {
        const hh = `${leadingZero(hours)}${hours}`;
        const mm = `${leadingZero(minutes)}${minutes}`;
        const ss = `${leadingZero(seconds)}${seconds}`;
        let timeStr = `${hh}:${mm}`;
        if (!props.hideSeconds) {
            timeStr += `:${ss}`;
        }

        if (days === 0) {
            return <span>{timeStr}</span>;
        } else {
            let str = ngettext('{days} день', '{days} дня', days) + `&nbsp;${timeStr}`;
            if (props.dynamicSettings) {
                if (props.dynamicSettings.maxDays && days > props.dynamicSettings.maxDays) {
                    str = ngettext('{days} день', '{days} дня', days);
                }
            }

            const interpolateStr = interpolate(str, {
                days: days,
            });

            return <span dangerouslySetInnerHTML={{ __html: interpolateStr }} />;
        }
    };

    return (
        <div
            className={classNames(isLarge ? styles.largeWrapper : styles.wrapper, props.className, {
                [styles.notice]: props.notice,
                [styles.withoutIcon]: props.withoutIcon,
            })}
        >
            <DivTooltip tooltipBody={tooltipText ? <DefaultTooltip text={tooltipText} /> : null}>
                <Countdown date={date} renderer={renderer} onComplete={onComplete} />
            </DivTooltip>
        </div>
    );
};

export default CountDown;
